import React, { useEffect } from "react";
import {
  headerSet,
} from "../Helper/CssHelper";
function Test() {
  function animation() {
    const section = document.getElementById("test-section");
    section.classList.remove("section-show");
    setTimeout(function () {
      section.classList.add("section-show");
    }, 350);
  }
  useEffect(() => {
    animation();
    headerSet();
    // showNavLink("portfolio", "portfolio-section");
  }, []);
  return (
    <div>
      {/* <!-- ======= Portfolio Section ======= --> */}
      <section id="test-section" class="portfolio section-show">
        <div class="container">
          <div class="section-title">
            <h2>Portfolio</h2>
            <p>My Works</p>
          </div>

          <div class="row">
            <div class="col-lg-12 d-flex justify-content-center">
              <ul id="portfolio-flters">
                <li data-filter="*" class="filter-active">
                  All
                </li>
                <li data-filter=".filter-app">App</li>
                <li data-filter=".filter-card">Card</li>
                <li data-filter=".filter-web">Web</li>
              </ul>
            </div>
          </div>

          <div class="row portfolio-container">
            <div class="col-lg-4 col-md-6 portfolio-item filter-app">
              <div class="portfolio-wrap">
                <img
                  src="assets/img/portfolio/portfolio-1.jpg"
                  class="img-fluid"
                  alt=""
                />
                <div class="portfolio-info">
                  <h4>App 1</h4>
                  <p>App</p>
                  <div class="portfolio-links">
                    <a
                      href="assets/img/portfolio/portfolio-1.jpg"
                      data-gallery="portfolioGallery"
                      class="portfolio-lightbox"
                      title="App 1"
                    >
                      <i class="bx bx-plus"></i>
                    </a>
                    <a
                      href="portfolio-details.html"
                      data-gallery="portfolioDetailsGallery"
                      data-glightbox="type: external"
                      class="portfolio-details-lightbox"
                      title="Portfolio Details"
                    >
                      <i class="bx bx-link"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 portfolio-item filter-web">
              <div class="portfolio-wrap">
                <img
                  src="assets/img/portfolio/portfolio-2.jpg"
                  class="img-fluid"
                  alt=""
                />
                <div class="portfolio-info">
                  <h4>Web 3</h4>
                  <p>Web</p>
                  <div class="portfolio-links">
                    <a
                      href="assets/img/portfolio/portfolio-2.jpg"
                      data-gallery="portfolioGallery"
                      class="portfolio-lightbox"
                      title="Web 3"
                    >
                      <i class="bx bx-plus"></i>
                    </a>
                    <a
                      href="portfolio-details.html"
                      data-gallery="portfolioDetailsGallery"
                      data-glightbox="type: external"
                      class="portfolio-details-lightbox"
                      title="Portfolio Details"
                    >
                      <i class="bx bx-link"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 portfolio-item filter-app">
              <div class="portfolio-wrap">
                <img
                  src="assets/img/portfolio/portfolio-3.jpg"
                  class="img-fluid"
                  alt=""
                />
                <div class="portfolio-info">
                  <h4>App 2</h4>
                  <p>App</p>
                  <div class="portfolio-links">
                    <a
                      href="assets/img/portfolio/portfolio-3.jpg"
                      data-gallery="portfolioGallery"
                      class="portfolio-lightbox"
                      title="App 2"
                    >
                      <i class="bx bx-plus"></i>
                    </a>
                    <a
                      href="portfolio-details.html"
                      data-gallery="portfolioDetailsGallery"
                      data-glightbox="type: external"
                      class="portfolio-details-lightbox"
                      title="Portfolio Details"
                    >
                      <i class="bx bx-link"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 portfolio-item filter-web">
              <div class="portfolio-wrap">
                <img
                  src="assets/img/portfolio/portfolio-9.jpg"
                  class="img-fluid"
                  alt=""
                />
                <div class="portfolio-info">
                  <h4>Web 3</h4>
                  <p>Web</p>
                  <div class="portfolio-links">
                    <a
                      href="assets/img/portfolio/portfolio-9.jpg"
                      data-gallery="portfolioGallery"
                      class="portfolio-lightbox"
                      title="Web 3"
                    >
                      <i class="bx bx-plus"></i>
                    </a>
                    <a
                      href="portfolio-details.html"
                      data-gallery="portfolioDetailsGallery"
                      data-glightbox="type: external"
                      class="portfolio-details-lightbox"
                      title="Portfolio Details"
                    >
                      <i class="bx bx-link"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- End Portfolio Section --> */}
      </section>
    </div>
  );
}

export default Test;
